import React from 'react';
import { CheckCircle2Icon, ShoppingBagIcon, CalendarIcon, SparklesIcon } from 'lucide-react';
export function BenefitsSection() {
  return <section className="w-full bg-cream py-16 md:py-24 px-4" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-brown-primary mb-4" data-id="element-4">
            Lo que descubrirás dentro
          </h2>
          <p className="text-brown-secondary text-lg" data-id="element-5">
            Todo lo que necesitas para transformar tu piel
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-6">
          {/* Benefit 1 */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-cream-dark hover:border-rose-gold/30 transition-colors" data-id="element-7">
            <div className="w-12 h-12 bg-rose-gold/10 rounded-full flex items-center justify-center mb-6" data-id="element-8">
              <ShoppingBagIcon className="w-6 h-6 text-rose-gold" data-id="element-9" />
            </div>
            <h3 className="text-xl font-bold text-brown-primary mb-3" data-id="element-10">
              La Lista de Compras Exacta
            </h3>
            <p className="text-brown-secondary" data-id="element-11">
              Nombres de productos que consigues en Farmacias Similares, del
              Ahorro o Benavides por menos de $200 MXN.
            </p>
          </div>

          {/* Benefit 2 */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-cream-dark hover:border-rose-gold/30 transition-colors" data-id="element-12">
            <div className="w-12 h-12 bg-rose-gold/10 rounded-full flex items-center justify-center mb-6" data-id="element-13">
              <SparklesIcon className="w-6 h-6 text-rose-gold" data-id="element-14" />
            </div>
            <h3 className="text-xl font-bold text-brown-primary mb-3" data-id="element-15">
              El Ciclo de 4 Noches (Skin-Cycling)
            </h3>
            <p className="text-brown-secondary" data-id="element-16">
              El orden exacto para exfoliar, renovar y recuperar tu piel sin
              causar rojeces ni irritación.
            </p>
          </div>

          {/* Benefit 3 */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-cream-dark hover:border-rose-gold/30 transition-colors" data-id="element-17">
            <div className="w-12 h-12 bg-rose-gold/10 rounded-full flex items-center justify-center mb-6" data-id="element-18">
              <CheckCircle2Icon className="w-6 h-6 text-rose-gold" data-id="element-19" />
            </div>
            <h3 className="text-xl font-bold text-brown-primary mb-3" data-id="element-20">
              Cierre de Poros 101
            </h3>
            <p className="text-brown-secondary" data-id="element-21">
              Cómo limpiar profundamente sin resecar, eliminando la textura
              irregular para siempre.
            </p>
          </div>

          {/* Benefit 4 */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-cream-dark hover:border-rose-gold/30 transition-colors" data-id="element-22">
            <div className="w-12 h-12 bg-rose-gold/10 rounded-full flex items-center justify-center mb-6" data-id="element-23">
              <CalendarIcon className="w-6 h-6 text-rose-gold" data-id="element-24" />
            </div>
            <h3 className="text-xl font-bold text-brown-primary mb-3" data-id="element-25">
              Calendario de 14 Días
            </h3>
            <p className="text-brown-secondary" data-id="element-26">
              Un checklist diario para que no tengas que pensar, solo actuar.
              Imprímelo y pégalo en tu espejo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}